module.exports = {"id":"s6-q5","text":"Are you comfortable submitting information on your phone using apps or a web browser?","multiselect":false,"next":"finish","options":[{"id":"s6-q5-a1","text":"Yes","capability":2,"access":2,"focusarea":[4,0,0,0,4]},{"id":"s6-q5-a2","text":"No","capability":-2,"access":-3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s6-q5.json
// module id = 920
// module chunks = 41